import { Component, Prop, Vue } from "vue-property-decorator";

// External components
import MultiselectInput from "../multiselectInput";

@Component({ components: { MultiselectInput } })
export default class DocumentMultiselectInput extends Vue {
  @Prop({ default: null }) userForm;
  @Prop({ default: false }) isMissingDocument;

  documentTypes = ["cc", "ce"];
}
